import {
    ChangeDetectorRef,
    Component,
    DestroyRef,
    inject,
} from "@angular/core";
import { PathHistory } from "../header/header.component";
import { FavoritesService } from "@app/services/favorites.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Router } from "@angular/router";
import { AuthGuardService } from "@app/services/auth-guard.service";
import { Partner } from "@app/models/partner/IPartner";
import { MatBadge } from "@angular/material/badge";
import { MenuService } from "@app/services/menu.service";
import { DirectiveModule } from "@app/directives/directive.module";
import { CommonModule } from "@angular/common";

@Component({
    selector: "coral-toolbar",
    templateUrl: "./coraltoolbar.component.html",
    styleUrls: ["./coraltoolbar.component.scss"],
    imports: [CommonModule, MatBadge, DirectiveModule],
})
export class CoralToolbarComponent {
    constructor(
        protected favoritesService: FavoritesService,
        protected router: Router,
        protected cdr: ChangeDetectorRef,
        protected guardService: AuthGuardService,
        protected menuService: MenuService
    ) {
        this.initFavoriten();
    }

    menuactive: boolean = false;
    showSearch: boolean = false;
    tooltiptext: string = "";
    destroyRef = inject(DestroyRef);
    pathHistory: PathHistory;
    favoritesCount: number = 0;
    offerpackCount: number = 0;
    partner: Partner;

    openMenu(ev) {
        ev.stopPropagation();
        this.menuService.menu = true;
    }

    toggleSearch(ev) {
        ev.stopPropagation();
        this.showSearch = !this.showSearch;
        this.menuService.search = this.showSearch;
    }

    async initFavoriten() {
        this.favoritesService.favorites$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((count: number) => {
                this.favoritesCount = count;
            });
    }

    async gotofavorites() {
        const url = this.router.createUrlTree(["favorites"]).toString();
        this.router.navigateByUrl(url);
    }

    async initPartner() {
        this.guardService.getPartner$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((obj) => {
                if (obj?.partnerid?.length > 0) {
                    this.partner = obj;
                    this.tooltiptext =
                        this.partner?.tel +
                        "\nBeratung & Buchung täglich von \n\n" +
                        (this.partner?.opening_period
                            ? this.partner.opening_period
                            : "08 - 23 Uhr");
                    this.cdr.detectChanges();
                } else {
                    this.partner = null;
                }
            });
    }
}
